'use client';

import { Card } from '@packages/shared/src/ui/Card/Card';
import type { ReactNode } from 'react';
import { ProductImageRowList } from '../ProductImageRowList/ProductImageRowList.client';
import type { ProductItem } from '../ProductImageRowList/ProductImageRowList.client';

export type AccountItemCardProps = {
  /** Items to display (max 3 will be shown) */
  items: ProductItem[];
  /** Count of additional items beyond the visible ones */
  additionalCount: number;
  /** Order number for the card key */
  orderNo: string;
  /** Set of loaded image URLs for skeleton state management */
  /** Optional children to render below the images */
  children?: ReactNode;
  /** Optional className for the card wrapper */
  className?: string;
};

/**
 * AccountItemCard displays a card with product images and optional content.
 * Used by OrdersCard and ReturnsCard for consistent layout.
 */
export const AccountItemCard = ({
  items,
  additionalCount,
  orderNo,
  children,
  className = 'px-1.5 py-1.5',
}: AccountItemCardProps) => (
  <Card key={orderNo} className={className}>
    <ProductImageRowList items={items} additionalItemsCount={additionalCount} keyPrefix={orderNo} />
    {/* Optional children content */}
    {children}
  </Card>
);
